
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import Footer from './components/Footer';


export default function SPonsors() {
  

  return (
    <>
    <section id="hero" className="hero hero-background  position-relative">
      <Container >
        <Row className="align-items-center">
            <Col md={8} lg={6} className=''>
              <h1 className="display-3 fw-bold text-white">Sponsors</h1>
            </Col>
          </Row>
      </Container>
    </section>

    <section id="content">
      
      <Container className='mb-5'>
        <Row className="py-5">
          <Col md={12} className='mb-4 '>
            <h2 className='h1 mb-4 purple-h'>Gold Sponsors</h2>
          </Col>
          <Col md={3} className='mb-4'>
              <Card className='border shadow rounded-4 h-100 clickable-card position-relative'>
                 <a href="https://analysisadria.si/" target="_blank" rel='noreferrer' className='stretched-link'> </a>
                <Card.Img variant="top" src="images/sponsor-adria.jpg" className='img-fluid'/>
                <Card.Body className='p-4'>
                  <h5>Analysis Adria</h5>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3} className='mb-4'>
              <Card className='border shadow rounded-4 h-100 clickable-card position-relative'>
                 <a href="https://www.bia.si/" target="_blank" rel='noreferrer' className='stretched-link'> </a>
                <Card.Img variant="top" src="images/sponsor-bia.jpg" className='img-fluid'/>
                <Card.Body className='p-4'>
                  <h5>BIA</h5>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3} className='mb-4'>
             
              <Card className='border shadow rounded-4 h-100 clickable-card position-relative'>
                 <a href="https://www.parrinst.com" target="_blank" rel='noreferrer' className='stretched-link'> </a>
                <Card.Img variant="top" src="images/sponsor-parr.jpg" className='img-fluid'/>
                <Card.Body className='p-4'>
                  <h5>Parr Instrument Company</h5>
                </Card.Body>
              </Card>

            </Col>
            <Col md={3} className='mb-4'>
              <Card className='border shadow rounded-4 h-100 clickable-card position-relative'>
                 <a href="https://www.donaulab.si/" target="_blank" rel='noreferrer' className='stretched-link'> </a>
                <Card.Img variant="top" src="images/sponsor-donau.jpg" className='img-fluid'/>
                <Card.Body className='p-4'>
                  <h5>Donau Lab</h5>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row className="py-5">
          <Col md={12} className='mb-4 '>
            <h2 className='h1 mb-4 purple-h'>Silver Sponsors</h2>
          </Col>
            <Col md={3} className='mb-4'>
              <Card className='border shadow rounded-4 h-100 clickable-card position-relative'>
                 <a href="https://www.aciesbio.com/" target="_blank" rel='noreferrer' className='stretched-link'> </a>
                <Card.Img variant="top" src="images/sponsor-acies.jpg" className='img-fluid'/>
                <Card.Body className='p-4'>
                  <h5>Acies Bio</h5>
                </Card.Body>
              </Card>
            </Col>  
            <Col md={3} className='mb-4'>
              <Card className='border shadow rounded-4 h-100 clickable-card position-relative'>
                 <a href="https://cppe.si/" target="_blank" rel='noreferrer' className='stretched-link'> </a>
                <Card.Img variant="top" src="images/sponsor-cppe.jpg" className='img-fluid'/>
                <Card.Body className='p-4'>
                  <h5>CPPE</h5>
                </Card.Body>
              </Card>
            </Col>
            
          </Row>
          <Row className="py-5">
          <Col md={12} className='mb-4 '>
            <h2 className='h1 mb-4 purple-h'>Supporters</h2>
          </Col>
            <Col md={3} className='mb-4'>
              <Card className='border shadow rounded-4 h-100 clickable-card position-relative'>
                 <a href="https://www.ocean4biotech.eu/" target="_blank" rel='noreferrer' className='stretched-link'> </a>
                <Card.Img variant="top" src="images/sponsor-ocean4.jpg" className='img-fluid'/>
                <Card.Body className='p-4'>
                  <h5>Ocean4Biotech</h5>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3} className='mb-4'>
              <Card className='border shadow rounded-4 h-100 clickable-card position-relative'>
                 <a href="#" target="_blank" rel='noreferrer' className='stretched-link'> </a>
                <Card.Img variant="top" src="images/sponsor-shell.jpg" className='img-fluid'/>
                <Card.Body className='p-4'>
                  <h5>Shell2Value</h5>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3} className='mb-4'>
              <Card className='border shadow rounded-4 h-100 clickable-card position-relative'>
                 <a href="#" target="_blank" rel='noreferrer' className='stretched-link'> </a>
                <Card.Img variant="top" src="images/sponsor-SPAT.jpg" className='img-fluid'/>
                <Card.Body className='p-4'>
                  <h5>SPAT-eCat</h5>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3} className='mb-4'>
              <Card className='border shadow rounded-4 h-100 clickable-card position-relative'>
                 <a href="https://toxbox.eu/" target="_blank" rel='noreferrer' className='stretched-link'> </a>
                <Card.Img variant="top" src="images/sponsor-toxbox.jpg" className='img-fluid'/>
                <Card.Body className='p-4'>
                  <h5>ToxBox</h5>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row className="py-5">
          <Col md={12} className='mb-4 '>
            <h2 className='h1 mb-4 purple-h'>Sponsorhip Opportunities</h2>
            <p>Explore the available sponsorship packages for BPP 2026, including visibility options, exhibition opportunities, and tailored collaboration formats.</p>
            <Button href="files/BPP2026_Sponsorship_Opportunities.pdf" target='_blank' variant="outline-bpp-pink" size="lg" className='text-white_ mt-3'>Download sposorship deck</Button>
          </Col>
            
          </Row>
      </Container>
    </section>

     
      <Footer />


    </>
  );
}
 